<template>
	<div ref="navBarRef">
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const navBarRef = ref(null)

const getNavBarHeight = () => {
	return navBarRef.value.getBoundingClientRect().height
}

onMounted(() => {
	const height = getNavBarHeight()

	gsap.fromTo(navBarRef.value,
		{ "--nav-shadow": 0 },
		{
			scrollTrigger: {
				trigger: "header",
				start: `bottom top+=${height}`,
				markers: false,
				toggleActions: "play none none reverse"
			},
			"--nav-shadow": 0.15,
			duration: 0.3
		}
	);
})

onUpdated(() => {
	ScrollTrigger.refresh()
})

</script>
